<div class="row justify-content-center mb-4">
    <div class="col-12 text-center mb-3">Collect additional information from donors for each item bought of this option type.</div>
    <button
        class="btn btn--paybee btn--black"
        (click)="addFormField()"
    >Add Question</button>
</div>
<ng-container [formGroup]="presetOption">
    <ul class="list-group ui-sortable" formArrayName="shoppingForm" cdkDropList (cdkDropListDropped)="dropOption($event)">
        <ng-container *ngFor="let option of options.controls;index as i;">
            <li class="list-group-item" *ngIf="option.value.status != 1" cdkDragLockAxis="y" cdkDrag>
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="preset-option d-flex">
                    <div class="preset-option__drag-and-drop d-flex align-items-center justify-content-center">
                        <app-icon-menu></app-icon-menu>
                    </div>
                    <ng-container [formGroup]="option">
                        <div class="preset-option__content d-flex align-items-center">
                            <div class="preset-option__number">{{i+1}}.</div>
                            <div class="preset-option__container d-flex flex-column">
                                <div class="preset-option__name mb-1">{{option.value.name}}</div>
                            </div>
                            <div class="preset-option__actions">
                                <div class="preset-option__action">
                                    <app-icon-pen (click)="editFormField(option.value, i)"></app-icon-pen>
                                </div>
                                <div class="preset-option__action" (click)="removeOption(i)">
                                    <app-icon-trash></app-icon-trash>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </li>
        </ng-container>
    </ul>
</ng-container>